import { store } from "../../appRedux/store/Store";

export function isLoggedIn() {
   const state = store.getState();

   return Boolean(state.auth?.authUser?.id);
}
